var map = {
	"./chart_icon.svg": 693,
	"./chart_icon_selected.svg": 14257,
	"./chart_icon_selected_mobile.svg": 57893,
	"./chat_icon.svg": 15369,
	"./chat_icon_selected.svg": 94296,
	"./chat_icon_selected_mobile.svg": 46176,
	"./email_icon.svg": 11469,
	"./email_icon_selected.svg": 75468,
	"./email_icon_selected_mobile.svg": 70072,
	"./event_icon.svg": 22416,
	"./event_icon_selected.svg": 29346,
	"./event_icon_selected_mobile.svg": 22564,
	"./help_icon.svg": 3423,
	"./help_icon_selected.svg": 16599,
	"./help_icon_selected_mobile.svg": 42142,
	"./home_icon.svg": 47314,
	"./home_icon_selected.svg": 64032,
	"./home_icon_selected_mobile.svg": 20844,
	"./icon.png": 94329,
	"./logout_icon.svg": 94764,
	"./multi_user.svg": 44480,
	"./multi_user_selected.svg": 85201,
	"./multi_user_selected_mobile.svg": 94156,
	"./setting_icon.svg": 53826,
	"./setting_icon_selected.svg": 78078,
	"./setting_icon_selected_mobile.svg": 16228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92166;